import dropdownService from '../../services/dropdownService';

const state = {
  baseUrl: '/dropdowns-admin',
  list: [],
  loading: false,
  current: null
};

const actions = {
  list({ dispatch, commit }, { router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('setList', { list: [] });
    commit('startRequest');

    dropdownService
      .list()
      .then(rows => {
        commit('setList', { list: Array.isArray(rows) ? rows : [] });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  getOne({ dispatch, commit }, { key, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');
    commit('setCurrent', { doc: null });

    dropdownService
      .getAdminByKey({ key })
      .then(doc => {
        commit('setCurrent', { doc });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  postOne({ dispatch, commit }, { payload, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    dropdownService
      .postOne({ payload })
      .then(() => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: 'Dropdown has been created.'
          },
          { root: true }
        );
        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  patchOne({ dispatch, commit }, { key, payload, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    dropdownService
      .patchOne({ key, payload })
      .then(() => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: 'Dropdown has been updated.'
          },
          { root: true }
        );
        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  deleteOne({ dispatch, commit }, { key, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    dropdownService
      .deleteOne({ key })
      .then(() => {
        dispatch('list', { router });
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: 'Dropdown has been deleted.'
          },
          { root: true }
        );
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  }
};

const mutations = {
  startRequest(state) {
    state.loading = true;
  },
  requestFailed(state) {
    state.loading = false;
  },
  setList(state, { list }) {
    state.list = list;
    state.loading = false;
  },
  setCurrent(state, { doc }) {
    state.current = doc;
    state.loading = false;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
